import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { StripeEventModel } from "src/app/features/creatics/admin-console/components/cinejoy-event/model/stripe-envent.model";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
  })
  export class CinejoyEventService {

  neweEventAddedSignal:Subject<boolean>= new BehaviorSubject<boolean>(false);
  listUpdatedSignal:Subject<boolean>= new BehaviorSubject<boolean>(false);


  constructor(
    private http: HttpClient
  ) {
  }

  getEvent(eventId: number, eventType: string): Observable<any> {
    const params = new HttpParams()
      .set('eventId', eventId.toString())
      .set('eventType', eventType);

    const url = environment.apiURL + 'api/admin/stripe-product';
    return this.http.get(url, {params});
  }

  createSingleEvent(event: StripeEventModel): Observable<any> {
    const url = environment.apiURL + 'api/admin/stripe-product';
    return this.http.post(url, event);
  }

  CSVFileUpload(formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/admin/stripe-product/bulk-product`;

    return this.http.post(url, formData);
  }

  getAllCinejoyEvents() {
    const url: string = environment.apiURL + 'api/admin/stripe-products';
    return this.http.get(url);
  }
  getCreateBulkEventJobStatus(jobId:string){
    const url: string = `${environment.apiURL}api/admin/stripe-product/bulk-product/status/${jobId}`;
    return this.http.get(url);
  }
  deleteCinejoyEvent(eventId:string,eventType:string){
    const url:string= `${environment.apiURL}api/admin/delete-product`;
    return this.http.delete(url, {params:{eventId:eventId,eventType:eventType}})
  }
}
